import React from 'react';

import S from './Work.module.css';

const daysInMonth = (month, year) => new Date(year, month, 0).getDate();

const formatDate = (date) =>
  new Intl.DateTimeFormat('en-US', { dateStyle: 'medium' }).format(date);

const CountTime = ({
  from,
  to,
  className
}: {
  from: string;
  to?: string;
  className?: string;
}) => {
  const toDate = to || new Date().toISOString().split('T')[0];
  const [fy, fm, fd] = from.split('-').map((i) => parseInt(i, 10));
  const [ty, tm, td] = toDate.split('-').map((i) => parseInt(i, 10));

  // Calculate differences
  let years = ty - fy;
  let months = tm - fm;
  let days = td - fd;

  // Adjust days and months if necessary
  if (days < 0) {
    months -= 1;
    days += daysInMonth(tm === 1 ? 12 : tm - 1, tm === 1 ? ty - 1 : ty);
  }
  if (months < 0) {
    years -= 1;
    months += 12;
  }

  const resultTime = [
    years ? `${years}y` : '',
    months ? `${months}m` : '',
    days ? `${days}d` : ''
  ].filter(Boolean);

  return (
    <div className={className}>
      {to
        ? `${formatDate(new Date(from))} - ${formatDate(new Date(to))}`
        : `since ${formatDate(new Date(from))}`}{' '}
      ({resultTime.join(' ')})
    </div>
  );
};

const data = [
  {
    company: 'Atlassian',
    logo: '/img/career/atlassian.svg',
    time: {
      from: '2015-11-23'
    },
    positions: ['Sr. Software Engineer', 'Engineering Manager']
  },
  //   {
  //     company: 'GoIT',
  //     logo: '/img/career/goit.svg',
  //     time: {
  //       from: '2015-05-01',
  //       to: '2015-10-01'
  //     },
  //     positions: ['Frontend Mentor']
  //   },
  {
    company: 'MacPaw',
    logo: '/img/career/macpaw.svg',
    time: {
      from: '2010-08-30',
      to: '2015-10-30'
    },
    positions: ['Lead Frontend Developer']
  }
];

export const Work = () => (
  <ul className={S.root}>
    {data.map((item, idx) => (
      <li className={S.work} key={idx}>
        <picture>
          <img src={item.logo} alt={item.company} />
        </picture>
        <div>
          {item.positions.map((item, idx, self) => (
            <React.Fragment key={idx}>
              <strong key={idx} className={S.role}>
                {item}
              </strong>
              {idx + 1 < self.length ? ', ' : ''}
            </React.Fragment>
          ))}
          <br />
          at <strong>{item.company}</strong>
          <br />
          <CountTime {...item.time} className={S.time} />
        </div>
      </li>
    ))}
    <li>
      + 3 other full-time jobs as a <strong>Frontend Developer</strong>{' '}
      <CountTime from="2008-03-05" to="2010-08-15" className={S.time} />
      <br />+ loads of contract works as a <strong>Frontend</strong> or{' '}
      <strong>Fullstack Engineer</strong>
    </li>
  </ul>
);
